// Formats post and comment text.
// HTML-escapes input first to prevent XSS.
// Processes in segments so regex never runs on generated HTML.

function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

var MENTION_STYLE = 'color:%230066cc;text-decoration:none;font-weight:600';
var HASHTAG_STYLE = 'color:#555;text-decoration:none;font-weight:600';

function formatPlainSegment(s) {
  // Link confirmed {@username} mentions (from dropdown selection only).
  // Bare @username is NOT linked -- prevents broken links to nonexistent users.
  // Hashtags: both {#tag} and bare #tag are linked (tag pages don't require existing data).
  return s.replace(
    /\{@([a-zA-Z0-9_]+)\}|\{#([a-zA-Z0-9_]+)\}|(^|[^a-zA-Z0-9_])#([a-zA-Z0-9_]+)/g,
    function (match, wrappedUser, wrappedTag, bareTagPrefix, bareTag) {
      if (wrappedUser) {
        return (
          '<a href="/profile/' +
          wrappedUser +
          '" data-mention-link="true" style="' +
          MENTION_STYLE +
          '">@' +
          wrappedUser +
          '</a>'
        );
      }
      var tagname = wrappedTag || bareTag;
      var prefix = wrappedTag ? '' : bareTagPrefix || '';
      return (
        prefix +
        '<a href="/tags/' +
        tagname +
        '" data-mention-link="true" style="' +
        HASHTAG_STYLE +
        '">#' +
        tagname +
        '</a>'
      );
    }
  );
}

function buildMentionPill(mention, postArtist) {
  var href;
  if (mention.type === 'artist') {
    href = '/artist/' + encodeURIComponent(mention.artistName || mention.title);
  } else if (mention.type === 'song') {
    href =
      '/music/song?artist=' +
      encodeURIComponent(mention.artistName) +
      '&amp;song=' +
      encodeURIComponent(mention.title);
  } else {
    href =
      '/music/album?artist=' +
      encodeURIComponent(mention.artistName) +
      '&amp;album=' +
      encodeURIComponent(mention.title);
  }
  var pillContent;
  if (mention.type === 'artist') {
    pillContent =
      '<span style="font-weight:700">' +
      escapeHtml(mention.artistName || mention.title) +
      '</span>';
  } else {
    var sameArtist = postArtist && mention.artistName.toLowerCase() === postArtist.toLowerCase();
    pillContent =
      '<span style="font-weight:700;font-style:italic">' + escapeHtml(mention.title) + '</span>';
    if (!sameArtist) {
      pillContent +=
        ' - <span style="font-weight:700">' + escapeHtml(mention.artistName) + '</span>';
    }
  }
  return (
    '<a href="' +
    href +
    '" data-mention-link="true" style="background:#222;border-radius:3px;padding:0 5px;color:#fff;text-decoration:none;font-size:0.85em;line-height:1.4;white-space:nowrap;max-width:80%;overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:text-bottom">' +
    pillContent +
    '</a>\u2009'
  );
}

export default function formatText(text, musicMentions, postArtist) {
  if (!text) return '';
  var escaped = escapeHtml(text);

  // Split into segments: plain text and {mention:N} tokens
  var parts = escaped.split(/(\{mention:\d+\})/g);
  var result = '';
  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];
    var mentionMatch = part.match(/^\{mention:(\d+)\}$/);
    if (mentionMatch && musicMentions && musicMentions.length > 0) {
      var index = parseInt(mentionMatch[1], 10);
      var mention =
        musicMentions.find(function (m) {
          return m.placeholderIndex === index;
        }) || musicMentions[index];
      if (mention) {
        result += buildMentionPill(mention, postArtist);
      } else {
        result += part;
      }
    } else {
      // Plain text segment: safe to run @mention and #hashtag regex
      result += formatPlainSegment(part);
    }
  }
  return result;
}
